import { Tag } from "antd";
import BankerMandiComponent from "features/dashboard/BankerLogin/BankerMandiComponent";
import FarmerReportGaugeChart from "features/onboarding/users/farmer/FarmerReportGaugeChart";
import React, { Suspense, useState, useEffect, useRef } from "react";
import { Card, Spinner, Table, Button } from "react-bootstrap";
import Skeleton from "react-loading-skeleton";
import { CardBody } from "reactstrap";
import { Divider } from "@mui/material";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import jsPDF from "jspdf";
import { usePDF } from "react-to-pdf";

import domtoimage from "dom-to-image-more";
const BankerFarmModal = React.lazy(() =>
  import("features/dashboard/BankerLogin/BankerFarmModal")
);
const SummaryFarmerOnboarding = ({
  data,
  refetch,
  isLoading,
  applicationTabValue,
  RoleAcessParams,
  id,
}) => {
  const [analyticsmodal, setanalyticsmodal] = useState(false);
  const [plotDetails, setPlotDetails] = useState("");
  const farmerData = data?.data;
  const [tabIndex, setTabIndex] = useState(0);
  const targetRef = useRef(null);
  const { toPDF } = usePDF({ filename: "Farm Details.pdf" });
  const [loadingg, setLoading] = useState(false);
  const [AllFarms, setAllFarms] = useState([]);
  const [dropdownDownlaodOpen, setDropdownDownloadOpen] = useState(false);
  const [activeCard, setActiveCard] = useState("completeReport");
  const toggleDownloadDropdown = () =>
    setDropdownDownloadOpen(!dropdownDownlaodOpen);
  const debounce = (func, delay) => {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => func(...args), delay);
    };
  };

  const handlePotModal = debounce((e, data) => {
    // console.log("data plot", data);
    let payload = {
      summary_stats: data?.summary_stats,
      current_indices: data?.summary_stats?.current_indices,
      acs: data?.summary_stats?.acs,
      crop_health: data?.summary_stats?.crop_health,
      boundary: data?.boundary,
      land_mark: data?.land_mark,
      area: data?.declared_area,
      plot_name: data?.plot_name,
      latitude_1: data?.latitude_1,
      longitude_1: data?.longitude_1,
      scores: data?.scores,
      declared_area: data?.declared_area,
      plotId: data?.id,
    };
    setPlotDetails(payload);
    setanalyticsmodal(true);
  }, 300);

  const handleClose = () => {
    setanalyticsmodal(false);
    setPlotDetails({});
  };
  useEffect(() => {
    if (farmerData?.farm?.length > 0) {
      const filteredData = farmerData?.farm.filter(
        (item) => item.boundary_updated
      );
      // console.log("filteredData", filteredData);
      setAllFarms(filteredData);
      setTabIndex(0);
      handlePotModal(null, filteredData[0]);
    }
  }, [farmerData?.farm]);
  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
    const selectedFarm = AllFarms?.[newValue];
    if (selectedFarm) {
      handlePotModal(event, selectedFarm);
    }
  };
  const SkeletonLoader = () => (
    <>
      <Skeleton height={40} width={`80%`} />
      <Skeleton height={20} width={`60%`} style={{ marginTop: "10px" }} />
      <Skeleton height={20} width={`70%`} style={{ marginTop: "10px" }} />
      <Skeleton height={15} width={`60%`} style={{ marginTop: "10px" }} />
      <Skeleton height={15} width={`60%`} style={{ marginTop: "10px" }} />
      <Skeleton height={15} width={`60%`} style={{ marginTop: "10px" }} />
      <Skeleton height={10} width={`50%`} style={{ marginTop: "10px" }} />
      <Skeleton height={10} width={`50%`} style={{ marginTop: "10px" }} />
    </>
  );
  const handleDownloadPDF = async () => {
    if (!targetRef.current) return;

    setLoading(true);

    setTimeout(async () => {
      try {
        const imgData = await domtoimage.toPng(targetRef.current, {
          useCORS: true,
          bgcolor: "#fff",
          filter: (node) => {
            if (
              node.tagName === "LINK" &&
              node.href &&
              !node.href.startsWith(window.location.origin)
            ) {
              return false;
            }
            return true;
          },
        });

        const pdf = new jsPDF({
          orientation: "portrait",
          unit: "px",
          format: [
            targetRef.current.scrollWidth,
            targetRef.current.scrollHeight,
          ],
        });

        pdf.addImage(
          imgData,
          "PNG",
          0,
          0,
          targetRef.current.scrollWidth,
          targetRef.current.scrollHeight
        );
        // pdf.save("Farm Report.pdf");
        pdf.save(`${farmerData?.full_name}.pdf`);
      } catch (error) {
        console.error("Error capturing map as PDF:", error);
      } finally {
        setLoading(false);
      }
    }, 1000);
  };

  return (
    <>
      {/* <Row className="gx-2 gy-2 d-flex mb-4" >
      {[
        { label: 'Farms', value: farmerData?.farm?.length || 0, bg: '#dc70eb', icon: 'mdi-land-fields' },
        { label: 'Bank Accounts', value: farmerData?.banks?.length || 0, bg: '#7adbe8', icon: 'mdi-bank' },
        { label: 'Assets', value: farmerData?.assets?.length || 0, bg: '#e4ac64', icon: 'mdi-cube-outline	' },
        { label: 'Liabilities', value: farmerData?.liabilities?.length || 0, bg: '#6fe67d', icon: 'mdi-cash-minus' },
        { label: 'Family Members', value: farmerData?.family?.length || 0, bg: '#f1769a', icon: 'mdi-account-group' },
        { label: 'Addresses', value: farmerData?.addresses?.length || 0, bg: '#ffcf96', icon: 'mdi-map-marker' },
        { label: 'Crops', value: farmerData?.crops?.length || 0, bg: '#7adbe8', icon: 'mdi-seed' },
        { label: 'Media Files', value: farmerData?.media?.length || 0, bg: '#f7a76c', icon: 'mdi-file-image' }
        
      ].map((item, index) => (
        <Col key={index}>
          <div
            className="rounded text-center py-3 px-2"
            style={{
              color: item.bg,
              borderRadius: '0.75rem',
              fontSize: '0.8rem',
              boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
              backgroundColor:"white"
            }}
          >
            <div className="text-muted mb-1">  <i
          className={`mdi ${item.icon}`}
          style={{ fontSize: '1rem' }}
        ></i>&nbsp;&nbsp;{item.label}</div>
            <div className="fw-bold fs-5">{item.value}</div>
          </div>
        </Col>
      ))}
    </Row> */}

      <div className="row mt-2">
        <div className="col-lg-8">
          <Card className="shadow-sm border-0">
            <div className="heading-title mt-lg-0 mt-2 py-3">
              <h5
                className="mx-2"
                style={{
                  fontSize: "18px",
                  color: "black",
                }}
              >
                &nbsp;&nbsp;{" "}
                <i
                  className="mdi mdi-account-hard-hat me-2"
                  style={{ fontSize: "1.4rem", color: "#867f7f" }}
                ></i>
                Farmer Details
              </h5>
            </div>
            <Divider style={{ border: "1px dotted gray" }} />
            <CardBody className="p-3">
              <div
                id="gauge-chart"
                className="e-chart"
                style={{ height: "270px" }}
              >
                {isLoading ? (
                  <SkeletonLoader />
                ) : (
                  <>
                    <div className="d-lg-block d-md-block d-none">
                      <Table className="table mb-2 " hover>
                        <tbody className="">
                          <tr className="">
                            <th scope="row" className="align-middle">
                              Farmer Name:
                            </th>

                            <td className="align-middle">
                              {farmerData?.full_name}
                            </td>

                            <th scope="row" className="align-middle ps-4">
                              Age:
                            </th>
                            <td className="align-middle">{farmerData?.age}</td>
                          </tr>
                          <tr>
                            <th scope="row" className="align-middle">
                              Mobile:
                            </th>
                            <td className="align-middle">
                              {farmerData?.phone_number}
                            </td>
                            <th scope="row" className="align-middle">
                              Gender:
                            </th>
                            <td className="align-middle">
                              {farmerData?.gender}
                            </td>
                          </tr>
                          <tr>
                            <th scope="row" className="align-middle">
                              State:
                            </th>
                            <td className="align-middle">
                              {farmerData?.state_name}
                            </td>
                            <th scope="row" className="align-middle">
                              District:
                            </th>
                            <td className="align-middle">
                              {farmerData?.district_name}
                            </td>
                          </tr>
                          <tr>
                            <th scope="row" className="align-middle">
                              Pincode:
                            </th>
                            <td className="align-middle">
                              {farmerData?.pincode}
                            </td>
                            <th scope="row" className="align-middle">
                              Total Land Holding:
                            </th>
                            <td className="align-middle">
                              {farmerData?.calculated_land_holding} acres
                            </td>
                          </tr>
                        </tbody>
                      </Table>
                    </div>
                    <div className="d-lg-none d-md-none d-block">
                      <div>
                        <div
                          className="d-flex justify-content-between py-2 gap-3"
                          style={{
                            borderBottom: "1px solid #ebeaeab5",
                          }}
                        >
                          <div className="">
                            <h5 className="text-success m-0 text-capitalize">
                              {farmerData?.full_name || "N/A"}
                            </h5>
                            <h6 style={{ color: "#5c5c5cb3" }}>
                              {farmerData?.primary_occupation || "N/A"}
                            </h6>
                          </div>
                          <div className="d-flex justify-content-between align-items-center mt-2">
                            <span className="card-text d-flex gap-2">
                              <Tag
                                bordered={false}
                                style={{ fontWeight: "500" }}
                                color="geekblue"
                              >
                                {farmerData?.current_status
                                  ?.replaceAll("_", " ")
                                  .slice(0, 30)}
                                {farmerData?.current_status?.length > 30
                                  ? "..."
                                  : ""}
                              </Tag>
                            </span>
                          </div>
                        </div>

                        <div className="d-flex justify-content-between align-items-center mt-2 flex-wrap">
                          <span className="card-text d-flex gap-2">
                            <i className="mdi mdi-phone text-warning me-2 fs-6"></i>
                            <h6>Phone:</h6> {farmerData?.phone_number || "N/A"}
                          </span>
                          <span className="card-text d-flex gap-2">
                            <i className="mdi mdi-map-marker-radius text-warning me-2 fs-6"></i>
                            <h6>Pincode:</h6> {farmerData?.pincode || "N/A"}
                          </span>
                        </div>

                        <div className="card-text d-flex gap-2 mt-2">
                          <i className="mdi mdi-map-marker text-danger me-2 fs-6"></i>
                          {farmerData?.address || "N/A"}
                        </div>

                        <div className="d-flex flex-wrap gap-2 mt-2">
                          <span className="d-flex gap-1 flex-grow-1">
                            <i className="mdi mdi-land-plots text-success me-2 fs-6"></i>
                            <h6>Land Holding:</h6>
                            {farmerData?.calculated_land_holding
                              ? `${farmerData.calculated_land_holding} acres`
                              : "N/A"}
                          </span>

                          <div className="card-text d-flex   ">
                            <i className="mdi mdi-leaf text-success me-2 fs-6"></i>
                            <h6>Crops: </h6>
                            <span className="mx-1">
                              {" "}
                              {farmerData?.crops?.length > 0
                                ? farmerData.crops.map((item, index) => (
                                    <span key={index}>
                                      {item.crop_name}
                                      {index !== farmerData.crops.length - 1 &&
                                        ", "}
                                    </span>
                                  ))
                                : "N/A"}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </CardBody>
          </Card>
        </div>

        <div className="col-lg-4 col-12">
          <Card>
            <div className="relative w-full">
              <h5
                className="flex items-center justify-between rounded-topp-3 p-3 pr-10"
                style={{ marginTop: 3, color: "black" }}
              >
                <span>
                  <i className="mdi mdi-chart-line fs-6 me-2"></i>
                  {RoleAcessParams.includes("HCL")
                    ? "Farm Score"
                    : "Agriculture Credit Score"}
                </span>

                <a
                  href="https://firebasestorage.googleapis.com/v0/b/agrani-farmer.firebasestorage.app/o/acs.pdf?alt=media&token=caf9a11e-3bbc-46e1-ab6b-04edc879ec7b"
                  download
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-600 hover:text-blue-600"
                  title="Download PDF"
                  style={{ float: "right" }}
                >
                  <i className="mdi mdi-tray-arrow-down text-xl"></i>
                </a>
              </h5>
            </div>

            <Divider style={{ border: "1px dotted gray" }} />
            <CardBody className="p-2">
              {isLoading ? (
                <div className="p-3" style={{ height: "270x" }}>
                  <SkeletonLoader className="mt-3" />
                </div>
              ) : (
                <div id="gauge-chart" className="text-center pb-1">
                  <FarmerReportGaugeChart
                    farmerDataCl={farmerData?.total_acs}
                    chartName={
                      RoleAcessParams.includes("HCL")
                        ? "Farm Score"
                        : "Agriculture Credit Score"
                    }
                  />
                </div>
              )}
            </CardBody>
          </Card>
        </div>
        {/* {console.log("farmerData?.farm", plotDetails)} */}
        {plotDetails && (
          <div>
            <Card className="shadow-sm border-0 mb-4">
              <div className="d-flex justify-content-between align-items-center px-0 px-lg-3 px-md-3 py-2">
                <div className="heading-title mt-lg-0 mt-2">
                  <h5
                    style={{
                      fontSize: "18px",
                      color: "black",
                    }}
                  >
                    <i
                      className="mdi mdi-land-fields me-2"
                      style={{ fontSize: "1.4rem", color: "#867f7f" }}
                    ></i>
                    Farm Details
                  </h5>
                </div>

                {/* <Button
                    onClick={handleDownloadPDF}
                    className="buttonOrangeDefaultColor btn-sm"
                  >
                    {loadingg ? (
                      <>
                        <Spinner
                          animation="border"
                          size="sm"
                          className="me-2"
                        />
                        Generating...
                      </>
                    ) : (
                      <>
                        Download Report <i className="mdi mdi-download"></i>
                      </>
                    )}
                  </Button> */}
              </div>

              <Divider style={{ border: "1px dotted gray" }} />
              {isLoading ? (
                <div className="text-center mt-5">
                  <Spinner animation="border" size="lg" />
                </div>
              ) : (
                <CardBody className="p-3">
                  <div>
                    {farmerData?.farm?.length > 0 ? (
                      <>
                        {/* <div className="d-flex justify-content-between align-items-center mb-3">
                            <div className="flex-grow-1">
                              <Tabs
                                value={tabIndex}
                                onChange={handleTabChange}
                                variant="scrollable"
                                indicatorColor="primary"
                                textColor="primary"
                                className="responsive-tabs mb-0"
                              >
                                {AllFarms?.map((plot, index) => (
                                  <Tab
                                    key={index}
                                    label={`Plot ${index + 1}`}
                                    className="f14"
                                  />
                                ))}
                              </Tabs>
                            </div>

                          

                            <div className="d-flex justify-content-between align-items-center flex-wrap my-3 gap-3">
                              <div className="d-flex gap-4 flex-wrap">
                                <div className="d-flex align-items-center">
                                  <input
                                    type="radio"
                                    name="reportType"
                                    id="completeReport"
                                    value="completeReport"
                                    checked={activeCard === "completeReport"}
                                    className="form-check-input"
                                    onChange={() =>
                                      setActiveCard("completeReport")
                                    }
                                  />
                                  <label
                                    className="form-check-label mb-0 mx-2"
                                    htmlFor="completeReport"
                                  >
                                    Complete Report
                                  </label>
                                </div>

                                <div className="d-flex align-items-center">
                                  <input
                                    type="radio"
                                    name="reportType"
                                    id="historicalReport"
                                    value="historicalReport"
                                    checked={activeCard === "historicalReport"}
                                    className="form-check-input"
                                    onChange={() =>
                                      setActiveCard("historicalReport")
                                    }
                                  />
                                  <label
                                    className="form-check-label mb-0 mx-2"
                                    htmlFor="historicalReport"
                                  >
                                    Historical Report
                                  </label>
                                </div>

                                <div className="d-flex align-items-center">
                                  <input
                                    type="radio"
                                    name="reportType"
                                    id="currentReport"
                                    value="currentReport"
                                    checked={activeCard === "currentReport"}
                                    className="form-check-input"
                                    onChange={() =>
                                      setActiveCard("currentReport")
                                    }
                                  />
                                  <label
                                    className="form-check-label mb-0 mx-2"
                                    htmlFor="currentReport"
                                  >
                                    Current Report
                                  </label>
                                </div>
                              </div>

                              <Button
                                onClick={handleDownloadPDF}
                                className="buttonGreenDefaultColor btn-sm mt-2 mt-md-0"
                              >
                                {loadingg ? (
                                  <>
                                    <Spinner
                                      animation="border"
                                      size="sm"
                                      className="me-2"
                                    />
                                    Generating...
                                  </>
                                ) : (
                                  <>
                                    Download Report{" "}
                                    <i className="mdi mdi-download"></i>
                                  </>
                                )}
                              </Button>
                            </div>

                       
                          </div>
                            */}
                        <div className="row align-items-center mb-3">
                          <div className="col-12 col-md-6 mb-2 mb-md-0">
                            <Tabs
                              value={tabIndex}
                              onChange={handleTabChange}
                              indicatorColor="primary"
                              textColor="primary"
                              className="mb-0"
                              variant="scrollable"
                              scrollButtons="auto"
                              aria-label="scrollable auto tabs example"
                            >
                              {AllFarms?.map((plot, index) => (
                                <Tab
                                  key={index}
                                  label={`Plot ${index + 1}`}
                                  className="f14"
                                />
                              ))}
                            </Tabs>
                          </div>

                          <div className="col-12 col-md-6 d-flex flex-column flex-md-row justify-content-md-end align-items-md-center gap-3">
                            <div className="d-flex gap-4 flex-wrap justify-content-center justify-content-md-end">
                              {[
                                {
                                  id: "completeReportDesktop",
                                  label: "Complete Report",
                                  value: "completeReport",
                                },
                                {
                                  id: "historicalReportDesktop",
                                  label: "Historical Report",
                                  value: "historicalReport",
                                },
                                {
                                  id: "currentReportDesktop",
                                  label: "Current Report",
                                  value: "currentReport",
                                },
                              ].map((item) => (
                                <div
                                  key={item.id}
                                  className="d-flex align-items-center"
                                >
                                  <input
                                    type="radio"
                                    name="reportType"
                                    id={item.id}
                                    value={item.value}
                                    checked={activeCard === item.value}
                                    className="form-check-input"
                                    onChange={() => setActiveCard(item.value)}
                                  />
                                  <label
                                    className="form-check-label mb-0 mx-2"
                                    htmlFor={item.id}
                                  >
                                    {item.label}
                                  </label>
                                </div>
                              ))}
                            </div>

                            <Button
                              onClick={handleDownloadPDF}
                              className="buttonGreenDefaultColor btn-sm mt-2 mt-md-0"
                            >
                              {loadingg ? (
                                <>
                                  <Spinner
                                    animation="border"
                                    size="sm"
                                    className="me-2"
                                  />
                                  Generating...
                                </>
                              ) : (
                                <>
                                  Download Report{" "}
                                  <i className="mdi mdi-download"></i>
                                </>
                              )}
                            </Button>
                          </div>
                        </div>

                        {analyticsmodal && (
                          <Suspense
                            fallback={
                              <Spinner
                                animation="border"
                                className="text-center"
                              />
                            }
                          >
                            <div ref={targetRef}>
                              <BankerFarmModal
                                plotDetails={plotDetails}
                                state={farmerData?.state_name}
                                district={farmerData?.district_name}
                                full_name={farmerData?.full_name}
                                phone_number={farmerData?.phone_number}
                                unit={farmerData?.unit_of_land_holding}
                                RoleAcessParams={RoleAcessParams}
                                activeCard={activeCard}
                                id={id}
                              />
                            </div>
                          </Suspense>
                        )}
                      </>
                    ) : (
                      <p>No farm data available.</p>
                    )}
                  </div>
                </CardBody>
              )}
            </Card>
          </div>
        )}

        <Card>
          <BankerMandiComponent
            selectedState={farmerData?.state_name}
            selectedDistrict={farmerData?.district_name}
            crops={farmerData?.crops}
            applicationTabValue={applicationTabValue}
            RoleAcessParams={RoleAcessParams}
          />
        </Card>
        {farmerData?.crops?.length > 0 && (
          <div className="row">
            <div className="col-lg-12">
              <Card className="shadow-sm border-0 mb-4">
                <div className="heading-title mt-lg-0 mt-1 py-3">
                  <h5
                    className="mx-4"
                    style={{
                      fontSize: "18px",
                      color: "black",
                    }}
                  >
                    <i
                      className="mdi mdi-leaf me-2"
                      style={{ fontSize: "1.4rem", color: "#867f7f" }}
                    ></i>
                    Crop Details
                  </h5>
                </div>
                <Divider style={{ border: "1px dotted gray" }} />
                {isLoading ? (
                  <div className="text-center mt-5">
                    <Spinner animation="border" size="lg" />
                  </div>
                ) : (
                  <CardBody className="p-4">
                    <div className="table-responsive" id="familyid">
                      <Table hover className="table align-middle mb-0">
                        <thead className="table-light">
                          <tr>
                            <th>Image</th>
                            <th>Crop Name</th>
                            <th>Crop Year</th>
                            <th>Crop Season</th>
                            <th>Sowing Date</th>
                            <th>Harvest Date</th>
                            <th>Income</th>
                            <th>Crop Yield</th>
                          </tr>
                        </thead>

                        <tbody>
                          {Array.from(
                            new Map(
                              farmerData?.crops?.map((item) => [
                                item.crop_name,
                                item,
                              ])
                            ).values()
                          ).map((item, index) => (
                            <tr key={index} className="mt-3">
                              <td>
                                <img
                                  src={item.crop_image}
                                  alt="crop"
                                  style={{
                                    height: "40px",
                                    width: "40px",
                                    borderRadius: "50%",
                                    objectFit: "cover",
                                  }}
                                />
                              </td>
                              <td>{item.crop_name}</td>
                              <td>{item.year}</td>
                              <td>{item.season}</td>
                              <td>{item.sowing_date}</td>
                              <td>{item.harvest_date}</td>
                              <td>₹ {item.income}</td>
                              <td>{item.crop_yield}</td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </div>
                  </CardBody>
                )}
              </Card>
            </div>
          </div>
        )}

        {/* <Modal show={analyticsmodal} onHide={handleClose} size="xl">
        <Modal.Header closeButton>
          <Modal.Title className="fw-bold">
            Farm Report : {plotDetails?.plot_name}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
        {analyticsmodal&&

          <Suspense
            fallback={<Spinner animation="border" className="text-center" />}>
            <BankerFarmModal
              plotDetails={plotDetails}
              state={farmerData?.state_name}
              district={farmerData?.district_name}
              full_name={farmerData?.full_name}
              phone_number={farmerData?.phone_number}
              unit={farmerData?.unit_of_land_holding}
              RoleAcessParams={RoleAcessParams}
            />             
          </Suspense>
             }
        </Modal.Body>
        <Modal.Footer>
          <Button
            id="editDetails"
            type=""
            className="btn btn-danger waves-effect me-2 fs-6"
            onClick={handleClose}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal> */}
      </div>
    </>
  );
};

export default SummaryFarmerOnboarding;
